<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="partnerEmailTemplateList"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="550px"
          dataKey="templateId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          (onPage)="pageChange($event)"
          (onFilter)="applyFilter($event)"
          exportFilename="M365EventRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right; position: relative; top: 12px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr class="row">
              <th [pSortableColumn]="'templateName'" class="colsmall">
                Name<p-sortIcon [field]="'templateName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'createdOn'" class="colsmall">
                Create Date<p-sortIcon [field]="'CreatedOn'"> </p-sortIcon>
              </th>
              <th [pSortableColumn]="'templateDescription'" class="colsmall">
                Description<p-sortIcon
                  [field]="'templateDescription'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'templateId'" class="colsmall">Action</th>
              <th [pSortableColumn]="'templateId'" class="Edit">Edit</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr class="row">
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.templateName }}"
                  >{{
                    rowData.templateName.length > 20
                      ? (rowData.templateName | slice: 0 : 20) + '....'
                      : rowData.templateName
                  }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.createdOn }}"
                  >{{ rowData.createdOn | date: 'short' }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.templateDescription }}"
                  >{{
                    rowData.templateDescription.length > 20
                      ? (rowData.templateDescription | slice: 0 : 20) + '....'
                      : rowData.templateDescription
                  }}</span
                >
              </td>
              <td class="colsmall">
                <button
                  type="button"
                  pButton
                  icon="fa fa-file-zip-o"
                  iconPos="left"
                  (click)="OpenEmailTemplate(rowData.templateId)"
                  class="ui-button-success">
                  Preview/Send
                </button>
              </td>
              <td class="colsmall">
                <button
                  type="button"
                  pButton
                  icon="fa fa-pencil"
                  iconPos="left"
                  (click)="EditTemplate(rowData.templateId)">
                  Edit
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-dialog
    [(visible)]="isDialogOpen"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="false"
    styleClass="preview-modal"
    position="center">
    <ng-template #header>
      <div class="ui-g-11 edit-dialog-title">
        <span>Email Broadcast</span>
      </div>
      <div
        class="ui-g-1 closesidebar"
        style="cursor: pointer"
        (click)="CloseDialog()"
        (keydown.enter)="CloseDialog()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <div class="ui-g-12" style="height: 500px; overflow: auto">
      @if (errorMessage !== '') {
        <div class="ui-g-12">
          <div class="section-error">{{ errorMessage }}</div>
        </div>
      }
      @if (successMessage !== '') {
        <div class="ui-g-12">
          <div class="section-success">{{ successMessage }}</div>
        </div>
      }
      <div class="ui-g-12">
        <div class="section-head">Subject</div>
      </div>
      <div class="ui-g-12">
        <div class="section-body">{{ subjectTemplate }}</div>
      </div>
      <div class="ui-g-12">
        <div class="section-head">Email Template</div>
      </div>
      <div class="ui-g-12">
        <div [innerHTML]="htmlTemplate"></div>
      </div>
      <div class="ui-g-12">
        <div class="section-head">Recipients</div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-6">
          <p-multiSelect
            #tak
            appendTo="body"
            [options]="recipientCategory"
            placeholder="Recipient Cateogry"
            [(ngModel)]="selectedCategory"
            (onChange)="onRecipientCategory()"></p-multiSelect>
        </div>
      </div>
      <div class="ui-g-12">
        <div style="float: right">
          <div class="actionButton">
            <button
              type="button"
              [disabled]="!sendButtonEnable"
              pButton
              icon="fa fa-file-zip-o"
              iconPos="left"
              (click)="SendEmail()"
              class="ui-button-success">
              Send Email
            </button>
          </div>
          <div class="actionButton">
            <button
              type="button"
              pButton
              (click)="cancel()"
              class="ui-button-secondary flat fl-rt">
              Cancel
            </button>
          </div>
        </div>
      </div>
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
    </div>
  </p-dialog>

  <p-dialog
    [(visible)]="isEditDialogOpen"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="true"
    styleClass="preview-modal"
    position="center">
    <ng-template
      #header
      class="ui-g"
      style="margin-top: -45px; border-bottom: 1px solid #d2d2d2">
      <div class="ui-g-11 edit-dialog-title">
        <span>Edit - Email Information</span>
      </div>
      <div
        class="ui-g-1 closesidebar"
        (click)="CloseEditDialog()"
        (keydown.enter)="CloseEditDialog()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>

    <form [formGroup]="formEditTemplateDetails">
      @if (updateErrorMessage !== '') {
        <div class="ui-g-12">
          <div class="section-error">{{ updateErrorMessage }}</div>
        </div>
      }
      @if (updateSuccessMessage !== '') {
        <div class="ui-g-12">
          <div class="section-success">{{ updateSuccessMessage }}</div>
        </div>
      }
      <div class="ui-g-12">
        <div class="ui-g">
          <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1 section-head">
            Name:
          </div>
          <div class="ui-g-8 ui-md-8 ui-lg-8">
            <textarea
              pTextarea
              formControlName="templateName"
              ngDefaultControl
              rows="2"
              cols="60"
              required>
            </textarea>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g">
          <div class="ui-g-4 ui-md-4 ui-lg-3 ui-lg-offset-1 section-head">
            Description:
          </div>
          <div class="ui-g-8 ui-md-8 ui-lg-8">
            <textarea
              pTextarea
              pTextarea
              formControlName="templateDesc"
              ngDefaultControl
              rows="5"
              cols="60"
              required>
            </textarea>
          </div>
        </div>
      </div>
      <div class="ui-g-12 divButtons">
        <button
          type="button"
          pTooltip="Ok"
          tooltipPosition="top"
          class="ui-button-info btnpad btnmr button-ok"
          pButton
          (click)="onSave()">
          OK
        </button>
        <button
          type="button"
          pTooltip="Cancel"
          (click)="onCancel()"
          tooltipPosition="top"
          class="ui-button-info btnpad btnmr button-cancel"
          pButton>
          Cancel
        </button>
      </div>
    </form>
  </p-dialog>
</div>
